import { IIntegrationWrapper, IWrapperMediator } from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import { Signal } from "signals";
import { InitRecordSchema } from "slotworks/integration/revolver/schema/init-record-schema";
import { SpinResponseSchema } from "slotworks/integration/revolver/schema/spin-record-schema";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";

export class EveryMatrixWrapper implements IIntegrationWrapper, IWrapperMediator {
    public events = new Signal();
    
    public constructor() {
        window.addEventListener("message", function(event) {
            if(event && event.data && event.data.name == "stopAutospins") {
                StopAutoplayCommand();
            }
        });
    }

    public dispose = () => {
        this.events.removeAll();
        this.events = null;
    }

    public init = () => {}
    public quit = () => {}
    public gameDataLoaded = (response: InitRecordSchema) => {}
    public gameLoaded = () => {}
    public roundStart = (totalBet: number, balance: number) => {}
    public roundStarted = (spinId: number, balanceBefore: number) => {}
    public spinResponseReceived = (response: SpinResponseSchema) => {}
    public balanceUpdated = (balance: number) => {}
    public reportPaused = () => {}
    public roundEnd = (win: number, bet: number, balance: number) => {}
    public autoplayStart = () => {};
    public autoplayEnd = () => {};
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/emtrx/EmtrxWrapper.ts